module.exports = __webpack_public_path__ + "assets/img/deividas-varabauskas.a8a5c4c1.jpg";